import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Importfilebenxe from "components/Importfile/Benxe/Importfilebenxe.js";
export default function Importfile() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Import dữ liệu bến xe",
            tabContent: <Importfilebenxe />,
          },
        ]}
      />
    </div>
  );
}
